module.exports = __webpack_public_path__ + "static/media/close.e22dbab0.svg";